/**
 * randomUUID polyfill — Secure-Context-safe across HTTPS + plain-HTTP LAN.
 *
 * `crypto.randomUUID()` requires a Secure Context (HTTPS or localhost). On
 * plain-HTTP LAN origins (e.g., `http://vibe-{tenant}.t440.gamemagick.internal`
 * for game-coder-alpha) it is undefined → `TypeError: crypto.randomUUID is
 * not a function`. The bug was first surfaced 2026-05-30 in F-B (V1 Ship 2)
 * cross-isolation sweep for game-coder-alpha LAN: voiceTabsStore + chatTabsStore
 * cold-start paths crashed at the per-tab id-generation step, which prevented
 * ChatPanelPi (and VoicePanel tabs) from rendering.
 *
 * `crypto.getRandomValues` IS universally available (not Secure-Context
 * restricted), so we synthesize an RFC 4122 v4 UUID from random bytes. Same
 * algorithm as authService.ts had inline (extracted to this util for reuse
 * across voiceTabsStore + chatTabsStore + future call sites).
 */
export function randomUUID(): string {
  if (typeof crypto.randomUUID === 'function') return crypto.randomUUID();
  const b = new Uint8Array(16);
  crypto.getRandomValues(b);
  b[6] = (b[6] & 0x0f) | 0x40;  // version 4
  b[8] = (b[8] & 0x3f) | 0x80;  // variant 10
  const h = [...b].map((x) => x.toString(16).padStart(2, '0'));
  return `${h.slice(0, 4).join('')}-${h.slice(4, 6).join('')}-${h.slice(6, 8).join('')}-${h.slice(8, 10).join('')}-${h.slice(10, 16).join('')}`;
}
